import { useContext } from 'react';

import { SidePanelContext } from './context';

/**
 * Whether a side panel takes room beside the page, from opening until it has
 * slid shut. Below lg it overlays the page, so it takes none.
 */
const useSidePanelTakesRoom = (): boolean => useContext(SidePanelContext)?.panelTakesRoom ?? false;

export default useSidePanelTakesRoom;
